export default __webpack_public_path__ + "static/img-project-6-6cacc4f02cb04fb7df1c17272ebf2900.jpg";